<template>
  <div class="works_details">
    <van-nav-bar
      :title="$t('message.home.entry_details')"
      fixed
      placeholder
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="16" color="#323233" />
      </template>
    </van-nav-bar>
    <div class="swiper_div">
      <van-swipe :autoplay="0" :initial-swipe="initialSwipe">
        <van-swipe-item v-for="(image, index) in worksData.worksList" :key="index">
          <div v-if="worksData.worksList">
            <img @click="imgClick(index)" :src="image.workPath" />
          </div>
        </van-swipe-item>
        <van-swipe-item v-for="(video, index) in worksData.workVideoList" :key="index">
          <div v-if="worksData.workVideoList">
            <video :src="video" controls />
          </div>
        </van-swipe-item>
        <van-swipe-item v-for="video in worksData.workTiffList" :key="video">
          <div v-if="worksData.workTiffList">
            <video :src="video" controls />
            <!-- :ref="'video' + index"
              @pause="videoPause('video' + index)"
              @play="videoPlay('video' + index)" -->
            <!-- <div class="workStatus" v-if="worksData.workStatus != 4">未审核</div>
            <div class="workStatus" v-else>审核通过</div>
            <div class="play_btn" v-if="videoPlayShow" @click="videoPlay('video' + index)">
              <div class="play_btn_main"></div>
            </div> -->
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="works_details_user">
      <div class="works_details_user_top">
        <div class="works_details_user_top_left">
          <div class="works_details_user_top_img">
            <img :src="worksData.headImgUrl" alt="" v-if="worksData.headImgUrl" />
            <img src="../../../../static/image/user_img_head.jpg" />
          </div>
          <div class="works_details_user_top_name">{{ worksData.userNickname }}</div>
        </div>
        <div class="works_details_user_top_right">
          <i class="icon-jr-icon-data iconfont" style="margin-right: 4px"></i
          >{{ worksData.votes ? worksData.votes + 1 : 1 }}
          <span>{{ $t('message.home.votes') }}</span>
        </div>
      </div>
      <div class="works_details_user_bottom">
        <div class="works_details_user_bottom_left">
          {{ $t('message.home.up_on') }}{{ worksData.withoutTime }} |
          {{ worksData.competitionArea }}
        </div>
        <div class="works_details_user_bottom_right">
          <div class="works_details_user_bottom_icon">
            <i class="iconfont icon-jr-icon-eye-1"></i>
            {{ worksData.workViews }}
          </div>
          <div class="works_details_user_bottom_icon">
            <i class="icon-jr-icon-give iconfont"></i>
            {{ worksData.praiseCount }}
          </div>
        </div>
      </div>
      <div
        class="grade_award"
        v-if="(award != '' && award && showPrize) || (prizeName && showPrize)"
      >
        <img src="../../../../static/image/award-fill.png" alt="" />
        <span class="award">{{ prizeName || award }}</span>
      </div>
    </div>
    <div class="works_details_item">
      <div class="works_details_item_title">{{ worksData.workTitle }}</div>
      <p>{{ worksData.workDescribe }}</p>
    </div>
    <div class="works_details_nr" v-if="fromMy">
      <div class="works_details_nr_item">
        <i class="iconfont icon-jr-icon-trophy"></i>
        <p>{{ $t('message.home.works_in') }}《{{ worksData.activeName }}》</p>
        <button class="new_btn" @click="goComm">{{ $t('message.home.enter') }}</button>
      </div>
    </div>
    <div class="works_details_btn" v-if="fromMy && fromAward">
      <button class="next_btn" @click="ttClick">{{ $t('message.home.next_group') }}</button>
    </div>
    <div class="bottom" v-if="fromMy">
      <div class="bootom_btn" @click="show = true">
        <i class="iconfont icon-jr-icon-share"></i>
        <span>{{ $t('message.home.share') }}</span>
      </div>
      <div class="bootom_btn" @click="listWorskClick">
        <i class="iconfont icon-jr-icon-give blue" v-if="worksData.isLike"></i>
        <i class="iconfont icon-jr-icon-give" v-else></i>
        <span :class="worksData.isLike ? 'blue' : ''">{{ worksData.praiseCount }}</span>
      </div>
      <template v-if="worksData.exportAdvertising">
        <div class="bootom_tou" @click="voteClick">
          <i class="icon-jr-icon-like iconfont"></i>
          <!-- <span>{{ $t('message.home.Vote') }}</span> -->
          <span>{{
            worksData.exportAdvertising ? $t('message.home.VoteAss') : $t('message.home.Voted')
          }}</span>
        </div>
      </template>
      <template v-else>
        <div class="bootom_tou" v-if="!worksData.isVote" @click="voteClick">
          <i class="icon-jr-icon-like iconfont"></i>
          <!-- <span>{{ $t('message.home.Vote') }}</span> -->
          <span>{{
            worksData.exportAdvertising ? $t('message.home.VoteAss') : $t('message.home.Voted')
          }}</span>
        </div>
        <!-- 投票按钮 -->
        <div class="bootom_tou" v-else @click="voteClickNo">
          <i class="icon-jr-icon-like iconfont"></i>
          <!-- <span>{{ $t('message.home.Voted') }}</span> -->
          <span>{{
            worksData.exportAdvertising ? $t('message.home.VoteAss') : $t('message.home.Voted')
          }}</span>
        </div>
      </template>
    </div>
    <van-overlay :show="show">
      <div @click.stop class="share">
        <!-- ImagePreviewmap -->
        <div class="img"><img src="../../../../static/image/share.png" alt="" /></div>
        <span>{{ $t('message.home.click_friend') }}~</span>
        <div class="div" @click="show = false">{{ $t('message.home.my_know') }}</div>
      </div>
    </van-overlay>
    <van-image-preview
      v-model="showPreview"
      :startPosition="startPosition"
      :images="imgList"
      @change="onChange"
    >
      <template v-slot:index>
        {{ explain }}
      </template>
    </van-image-preview>
  </div>
</template>

<script>
import {
  activeWinningById,
  likeWorks,
  voteWorks,
  activeWinningList,
  getAccessToken
} from '@/api/activity'
import { wexinShare } from '@/utils/wxshare'
import { wxShare } from '@/api/common'
import { Toast } from 'vant'
import { getCookie } from '@/utils/cookie'
export default {
  name: 'worksDetails',
  computed: {
    id() {
      return this.$route.query.id
    },
    queryInfo() {
      return JSON.parse(this.$route.query.queryInfo)
    },
    pageNum() {
      return this.$route.query.pageNum
    },
    idList() {
      return JSON.parse(this.$route.query.idS)
    },
    pageSum() {
      return this.$route.query.pages
    },
    conditionsOfVoting() {
      return this.$route.query.conditionsOfVoting
    },
    showPrize() {
      return this.$route.query.showPrize == 'true' || this.$route.query.showPrize == true
    },
    prizeName() {
      return this.$route.query.prizeName
    }
  },
  data() {
    return {
      imgList: [],
      show: false,
      token: '',
      tokenShow: false,
      showPreview: false,
      explain: '', //图片说明
      worksData: {
        notShare: false,
        nextId: 0,
        activityId: '',
        id: '',
        isLike: false
      },
      fromMy: true,
      fromAward: true,
      videoPlayShow: true,
      idS: [], // 下一组需要的id
      nextIndex: 0,
      pages: 0, // 总共多少页数据
      nextPages: 1, // 下一组pages
      queryInfoData: {}, // 外界的数据
      award: '',
      initialSwipe: 0,
      startPosition: 0,
      worksIdList: [],
      activeEndTime: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/user/works') {
        // console.log(vm.fromMy)
        vm.fromMy = false
      } else if (from.path == '/myawards/awardslist') {
        vm.fromAward = false
      }
    })
  },
  created() {
    this.activeEndTime = this.$route.query.activeEndTime
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    this.token = getCookie('token')
    if (this.token) {
      this.tokenShow = true
    } else {
      this.tokenShow = false
    }

    if (this.$route.query.queryInfo) {
      this.queryInfoData = this.queryInfo
    }

    this.nextPages = this.pageNum
    if (this.$route.query.idS) {
      this.idS = this.idList
    }

    this.pages = this.pageSum
    this.listById(this.id)
    this.weixin()
  },

  methods: {
    async weixin() {
      var urls = window.location.href
      var title = ''
      var desc = ''
      const { data: res } = await wxShare({ url: urls })
      if (res.code === 102400) {
        if (this.worksData.notShare) {
          title = this.$t('message.home.yuanjing')
          desc = this.$t('message.home.china_yuanjing')
        } else {
          title = '我正在参加' + this.worksData.activeName
          desc = this.worksData.workTitle
        }
        var obj = {
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        }
        let shareData = {
          title: title, // 分享标题
          desc: desc,
          link: urls,
          // link: window.location.href,
          imgUrl:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/%E5%85%83%E6%99%AF%E4%BA%91logo-01.png' // 分享图标
        }
        wexinShare(obj, shareData)
      }
    },
    swipeChange(index) {
      const videoName = 'video' + index
      this.$refs[videoName][0].pause()
      this.videoPlayShow = true
    },
    videoPlay(videoName) {
      console.log(this.worksData.workStatus)
      if (this.worksData.workStatus != 4) {
        return Toast('审核未通过，暂不能查看！')
      }
      this.videoPlayShow = false
      this.$refs[videoName][0].controls = true
      this.$refs[videoName][0].play()
    },
    videoPause(videoName) {
      this.videoPlayShow = true
    },
    imgClick(index) {
      this.showPreview = true
      this.startPosition = index
      this.explain = this.worksData.worksList[0].pointsThat
    },
    onChange(item) {
      // console.log(item);
      this.initialSwipe = item
      this.explain = this.worksData.worksList[item].pointsThat
    },
    async voteListClick() {
      const now = 86400000
      const bol = Date.parse(new Date()) - Date.parse(new Date(this.activeEndTime)) > now * 7
      if (bol) {
        return Toast.fail(this.$t('message.home.voting_tips'))
      }
      const worksPraise = {
        worksId: this.worksData.id,
        conditionsOfVoting: this.conditionsOfVoting
      }

      const { data: res } = await voteWorks(worksPraise)
      if (res.resultCode === 200) {
        Toast.success(this.$t('message.home.succ_vote'))
        // this.listById(this.id)
        this.worksData.isVote = true
        this.worksData.votes += 1
        this.worksIdList.push(this.worksData.id)
      } else {
        Toast.fail(this.$t('message.home.network'))
      }
    },
    async voteClick() {
      let token = getCookie('token')
      if (!token) {
        this.$router.replace('/login')
        return Toast.fail('您未登录，请登录')
      } else {
        // 是否开启广告入口(默认0) 0->未开启;1->开启
        if (this.worksData.exportAdvertising) {
          const worksPraise = {
            worksId: this.worksData.id,
            conditionsOfVoting: this.conditionsOfVoting
          }
          const { data: res } = await voteWorks(worksPraise)
          // 根据message判断是否达到上限
          if (res.resultCode === 500 && res.data === 10510) {
            if (res.message === '当天观看次数已达到上限。') {
              Toast.fail(res.message)
            } else {
              Toast.fail('今日投票次数没有了，为你观看广告获取投票次数')
              const { data: res1 } = await getAccessToken({
                userId: getCookie('userId'),
                activeId: this.worksData.activityId,
                schema: sessionStorage.getItem('schema')
              })
              if (res1.resultCode === 200) {
                window.location.href = res1.data
              }
            }
          } else {
            Toast.success(this.$t('message.home.succ_vote'))
            // this.listById(this.id)
            this.worksData.isVote = true
            this.worksData.votes += 1
            this.worksIdList.push(this.worksData.id)
          }
        } else {
          this.voteListClick()
        }
      }
      // if (this.tokenShow) {
      //   this.voteListClick()
      // } else {
      //   Toast.fail(this.$t('message.home.log_first'))
      //   setTimeout(() => {
      //     this.$router.push({
      //       name: 'Login'
      //     })
      //   }, 1000)
      // }
    },
    voteClickNo() {
      Toast.fail(this.$t('message.home.entry_ready'))
    },
    async listWorsk() {
      const worksPraise = {
        worksId: this.worksData.id,
        conditionsOfVoting: this.conditionsOfVoting
      }
      const { data: res } = await likeWorks(worksPraise)
      if (res.resultCode === 200) {
        if (this.worksData.isLike) {
          Toast.success(this.$t('message.home.unlike'))
          this.listById(this.id)
        } else {
          Toast.success(this.$t('message.home.liked_suc'))
          this.listById(this.id)
        }
      } else {
        Toast.fail(this.$t('message.home.network'))
      }
    },
    listWorskClick() {
      if (this.tokenShow) {
        this.listWorsk()
      } else {
        Toast.fail(this.$t('message.home.log_first'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    goComm() {
      this.$router.push({
        name: 'ActivityDetails',
        query: { id: this.worksData.activityId }
      })
    },
    ttClick() {
      // if (this.worksData.nextId === 0) {
      //   Toast.fail(this.$t('message.home.next_not'))
      // } else {
      //   this.listById(this.worksData.nextId)
      // }

      // 点到最后一张了，继续点击后的判断
      if (this.nextIndex == this.idS.length) {
        // 如果现在的页数和总数据页数一样 那么说明后面没有数据了
        // console.log(this.pages)
        // console.log(this.nextPages)
        if (this.pages == this.nextPages) {
          return Toast.fail(this.$t('message.home.next_not'))
        } else {
          // 重置之前计数的索引
          this.nextIndex = 0
          // 重新刷新要发送请求的数据
          this.nextPages = this.nextPages * 1 + 1
          this.queryInfoData.pageNum = this.nextPages
          console.log(this.nextPages)
          // 重新调用数据 拿到最新的id数组 , 传递一个true里面去，等先拿到id数组再进行更新视图
          this.getActiveWinningListWeb(true)
          return
        }
      }

      this.listById(this.idS[this.nextIndex])
      this.nextIndex += 1
    },
    async getActiveWinningListWeb(value) {
      //  处理操作
      this.idS = []

      this.queryInfoData.language = sessionStorage.getItem('lang')
        ? sessionStorage.getItem('lang')
        : 'zhcn'
      this.queryInfo.conditionsOfVoting = this.conditionsOfVoting
      const { data: res } = await activeWinningList(this.queryInfoData)
      if (res.resultCode == 200) {
        this.pages = res.data.pages
        // console.log(this.pages)
        res.data.list.forEach((item, index) => {
          this.idS.push(item.id)
        })

        let idx = null
        this.idS.forEach((item, id) => {
          if (this.id == item) {
            return (idx = id)
          }
        })
        if (idx != null) {
          this.idS = this.idS.slice(idx + 1)
        }
      }
      if (value) {
        this.listById(this.idS[this.nextIndex])
        this.nextIndex += 1
      }
    },
    clickNo() {
      Toast.fail(this.$t('message.home.functionz_start'))
    },
    async listById(id) {
      console.log(this.conditionsOfVoting, '===????')
      const { data: res } = await activeWinningById({
        id: id,
        language: sessionStorage.getItem('lang'),
        conditionsOfVoting: this.conditionsOfVoting
      })
      if (res.resultCode === 200) {
        this.worksData = res.data
        this.award = res.data.award
        this.imgList =
          res.data.worksList &&
          res.data.worksList.map((el) => {
            return el.workPath
          })
      }
    },
    onClickLeft() {
      // this.$router.push({
      //   name: 'Works',
      //   query: { id: this.worksData.activityId }
      // })
      this.$router.go(-1)
      sessionStorage.setItem('worksIdList', JSON.stringify(this.worksIdList))
    }
  }
}
</script>

<style lang="less" scoped>
.works_details {
  width: 100%;
  overflow: hidden;

  /deep/ .van-image-preview__index {
    top: 75%;
    width: calc(100vw - 40px);
    font-size: 16px;
    padding: 0 20px;
  }

  .blue {
    color: #3562ff !important;
  }

  .share {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 30px;

    .img {
      width: 100%;
      overflow: hidden;
      margin: 30px 0;
    }

    img {
      width: 118px;
      height: 125px;
      float: right;
    }

    span {
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      display: block;
      text-align: right;
    }

    .div {
      width: 100px;
      text-align: center;
      line-height: 36px;
      border-radius: 16px;
      border: 1px solid #ffffff;
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      height: 36px;
      margin: 30px auto;
    }
  }

  .swiper_div {
    width: 100%;
    position: relative;

    img {
      // height: auto;
      // width: 100%;
      width: 100%;
      max-height: 600px;
      object-fit: contain;
    }

    /deep/ .van-swipe__track {
      align-items: center;
    }

    video {
      // height: auto;
      // width: 100%;

      width: 100%;
      max-height: 600px;
      object-fit: contain;
    }

    .workStatus {
      position: absolute;
      right: 0;
      top: 0;
      width: 64px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      // border-top-right-radius: 4px;
      border-bottom-left-radius: 8px;
      display: flex;
      justify-content: center;
    }

    .play_btn {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .play_btn_main {
      width: 20px;
      height: 20px;
      transform: translate(2px, 0);
      background-color: #ffffff;
      clip-path: polygon(0 0, 100% 50%, 0 100%);
    }
  }

  .works_details_user {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 10px;
    justify-content: space-between;

    .works_details_user_top {
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .works_details_user_top_left {
        flex: 1;
        display: flex;
        align-items: center;

        .works_details_user_top_img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 4px;

          img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
          }
        }

        .works_details_user_top_name {
          flex: 1;
          color: #151515;
          font-size: 16px;
          font-weight: 500;
        }
      }

      .works_details_user_top_right {
        display: flex;
        align-items: center;
        color: #359eff;
        font-size: 12px;
        font-weight: 12px;

        i {
          color: #359eff;
          font-size: 12px;
          font-weight: 12px;
        }

        span {
          color: #1a1a1a;
        }
      }
    }

    .works_details_user_bottom {
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;

      .works_details_user_bottom_left {
        color: #999999;
        font-size: 12px;
        font-weight: 400;
      }

      .works_details_user_bottom_right {
        color: #878787;
        font-size: 12px;
        font-weight: 400;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .works_details_user_bottom_icon {
          margin-left: 12px;
        }

        i {
          color: #878787;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    .grade_award {
      margin-top: 10px;
      // width: 73px;
      height: 24px;
      display: flex;

      img {
        display: block;
        width: 24px;
        height: 24px;
        background: #f3caae;
        border-radius: 2px 0px 0px 2px;
      }

      span {
        display: block;
        // width: 49px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #de8552;
        background: #fcefe2;
        text-indent: 6px;
        padding-right: 5px;
      }
    }
  }

  .works_details_item {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0px 16px;

    .works_details_item_title {
      box-sizing: border-box;
      width: 100%;
      padding: 10px 0;
      border-bottom: 1px solid #efefef;
      color: #151515;
      font-size: 20px;
      font-weight: 500;
    }

    p {
      color: #999999;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5em;
    }
  }

  .works_details_nr {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 16px;
    overflow: hidden;
    margin-top: 10px;

    .works_details_nr_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 12px;
      background: #f6f6f6;
      border-radius: 4px;

      i {
        color: #343434;
        font-size: 12px;
        margin-right: 4px;
      }

      p {
        margin: 0;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
        flex: 1;
      }

      .new_btn {
        width: 50px;
        height: 24px;
        text-align: center;
        margin-left: 20px;
        line-height: 24px;
        color: #359eff;
        font-size: 12px;
        border: none;
        font-weight: 400;
        background: rgba(53, 158, 255, 0.2);
        border-radius: 16px;
      }
    }
  }

  .works_details_btn {
    width: 100%;
    margin: 30px 0 80px 0;
    text-align: right;
    box-sizing: border-box;
    padding: 0 16px;
  }

  .next_btn {
    // width: 64px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 300;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 16px;
  }

  .bottom {
    width: 100%;
    overflow: hidden;
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    left: 0;
    box-sizing: border-box;
    padding: 0 16px;
    bottom: 0;
    background: #ffffff;

    .bootom_btn {
      widows: 94px;
      height: 34px;
      display: flex;
      align-items: center;

      i {
        color: #09121f;
        font-size: 14px;
        margin-right: 4px;
        font-weight: 400;
      }

      span {
        font-size: 14px;
        font-weight: 400;
        color: #151515;
      }
    }

    .bootom_tou {
      width: 120px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background: #3562ff;
      border-radius: 16px;

      i {
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        margin-right: 4px;
      }

      span {
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}
</style>
